import { Stack } from "@mui/material";
import { useContext } from "react";
import { ChromePicker, ColorResult } from "react-color";

import Context from "../../context";
import { CustomizeFormValues } from "../../hooks/customizeFormUtils";

type Props = {
	onClose: VoidFunction;
	name: keyof CustomizeFormValues;
};

export default function ColorPicker({ onClose, name }: Props) {
	const { actions, values } = useContext(Context);

	const changeColor = (color: ColorResult) => {
		actions.setValue(name, color.hex);
	};

	return (
		<Stack sx={{ position: "absolute", zIndex: 100, ml: -3, mt: 35 }}>
			<Stack
				sx={{ position: "fixed", top: "0px", right: "0px", bottom: "0px", left: "0px" }}
				onClick={onClose}
			/>
			<ChromePicker onChange={changeColor} color={values[name] as string} />
		</Stack>
	);
}
